"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewColonyPlanningInitiaitives = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var CardRequirements_1 = require("../CardRequirements");
var Card_1 = require("../Card");
var NewColonyPlanningInitiaitives = (function (_super) {
    __extends(NewColonyPlanningInitiaitives, _super);
    function NewColonyPlanningInitiaitives() {
        return _super.call(this, {
            name: CardName_1.CardName.NEW_COLONY_PLANNING_INITIAITIVES,
            cardType: CardType_1.CardType.AUTOMATED,
            cost: 6,
            tr: { moonColony: 1 },
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.colonyRate(2); }),
            metadata: {
                description: 'Requires Colony Rate to be 2 or higher. Raise the Colony Rate 1 step.',
                cardNumber: 'M31',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.moonColonyRate();
                }),
            },
        }) || this;
    }
    ;
    NewColonyPlanningInitiaitives.prototype.play = function (player) {
        MoonExpansion_1.MoonExpansion.raiseColonyRate(player);
        return undefined;
    };
    return NewColonyPlanningInitiaitives;
}(Card_1.Card));
exports.NewColonyPlanningInitiaitives = NewColonyPlanningInitiaitives;
